import { useMemo } from 'react';

import { useStores } from '../../../stores/useStores';
import type { TournamentWidgetDataType, WidgetEntry } from '../types';

export function useTournamentWidgets() {
  const { tournamentStore, tournamentOfChampionsStore } = useStores();
  const { hasLeaderboard, currentTournament } = tournamentStore;
  const isTocActive = tournamentOfChampionsStore.shouldShowWidget;

  const tournamentWidgets: TournamentWidgetDataType[] = useMemo(() => {
    if (isTocActive || !hasLeaderboard || !currentTournament) {
      return [];
    }
    return [
      {
        key: 'tournament',
        dataTestId: 'tournament-widget',
        event: currentTournament,
      },
    ];
  }, [currentTournament, hasLeaderboard, isTocActive]);

  return useMemo(
    () => tournamentWidgets.map((data): WidgetEntry<'tournament'> => ({ data, type: 'tournament', id: data.key })),
    [tournamentWidgets],
  );
}
